import { REDUX_ACTIONS, GAME_ID, TOAST_STATUSES } from 'a/pickyGoblins/data/constants';

const initState = {
  toastsStatus: [
    TOAST_STATUSES.DISABLED,
    TOAST_STATUSES.DISABLED,
    TOAST_STATUSES.DISABLED,
    TOAST_STATUSES.DISABLED,
  ],
};

const toastReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.TOAST_SET_STATUS: {
      const { toastsStatus } = state;
      toastsStatus[payload.index] = payload.status;
      return {
        ...state,
        toastsStatus,
      };
    }

    default:
      return state;
  }
};

export default toastReducer;
